// require('vanilla-cookieconsent');
import * as CookieConsent from "vanilla-cookieconsent";

$( document ).ready(function() {
    // let cc = initCookieConsent();
    CookieConsent.run({

        root: 'body',// root (parent) element where the modal will be appended as a last child
        mode: 'opt-in',// 'opt-in', 'opt-out'
        autoShow: true,// auto-show the consent modal if consent is not valid
        disablePageInteraction: false,// create a dark overlay and blocks the page scroll until consent is expressed
        hideFromBots: true,// prevent bots from indexing the modal's content.
        revision: 0,// manage consent revisions
        // intercept all script tags with a data-category attribute, and enables them based on the accepted categories
        manageScriptTags: true,
        // clear cookies when user rejects a specific category
        autoClearCookies: true,
        // delay the generation of the modal's markup until they're about to become visible
        // useful to improve the TTI score
        lazyHtmlGeneration: true,
        // customize the plugin's cookies
        cookie: {
            name: 'w2i_cookie',
            domain: window.location.hostname,
            path: '/',
            expiresAfterDays: 182,
            sameSite: 'Lax',
            useLocalStorage: false
        },
        guiOptions: {
            consentModal: {
                layout: 'bar',
                position: 'bottom center',
                flipButtons: true,
                equalWeightButtons: false
            },
            preferencesModal: {
                layout: 'box',
                position: 'right',
                flipButtons: false,
                equalWeightButtons: true
            }
        },
        // callbacks
        onFirstConsent: ({ cookie }) => {
            // console.log('onFirstConsent fired', cookie);
        },
        onConsent: ({ cookie }) => {
            // console.log('onConsent fired!', cookie);
            const consentMode = {
                'ad_storage': CookieConsent.acceptedCategory('analytics') ? 'granted' : 'denied',
                'ad_user_data': CookieConsent.acceptedCategory('analytics') ? 'granted' : 'denied',
                'personalization_storage': CookieConsent.acceptedCategory('analytics') ? 'granted' : 'denied',
                'analytics_storage': CookieConsent.acceptedCategory('analytics') ? 'granted' : 'denied',
                'functionality_storage': CookieConsent.acceptedCategory('necessary') ? 'granted' : 'denied',
                'security_storage': CookieConsent.acceptedCategory('necessary') ? 'granted' : 'denied',
            };
            gtag('consent', 'update', consentMode);
            localStorage.setItem('consentMode', JSON.stringify(consentMode))
        },
        onChange: ({ changedCategories, changedServices }) => {
            // console.log('onChange fired!', changedCategories, changedServices);
            const consentMode = {
                'ad_storage': CookieConsent.acceptedCategory('analytics') ? 'granted' : 'denied',
                'ad_user_data': CookieConsent.acceptedCategory('analytics') ? 'granted' : 'denied',
                'personalization_storage': CookieConsent.acceptedCategory('analytics') ? 'granted' : 'denied',
                'analytics_storage': CookieConsent.acceptedCategory('analytics') ? 'granted' : 'denied',
                'functionality_storage': CookieConsent.acceptedCategory('necessary') ? 'granted' : 'denied',
                'security_storage': CookieConsent.acceptedCategory('necessary') ? 'granted' : 'denied',
            };
            gtag('consent', 'update', consentMode);
            localStorage.setItem('consentMode', JSON.stringify(consentMode))
        },
        onModalReady: ({ modalName }) => {
            // console.log('ready:', modalName);
        },
        onModalShow: ({ modalName }) => {
            // console.log('visible:', modalName);
        },
        onModalHide: ({ modalName }) => {
            // console.log('hidden:', modalName);
        },
        categories: {
            necessary: {
                enabled: true,
                readOnly: true
            },
            analytics: {
                enabled: true,
                readOnly: false,
            },
        },
        language: {
            default: 'en',
            rtl: 'ar',  // enable RTL for Arabic
            autoDetect: 'document', // 'document', 'browser'
            translations: {
                en: {
                    consentModal: {
                        title: 'We use cookies',
                        description: 'Hi, this website uses essential cookies to ensure its proper operation and tracking cookies to understand how you interact with it. The latter will be set only after consent.',
                        acceptAllBtn: 'Accept all',
                        acceptNecessaryBtn: 'Reject all',
                        showPreferencesBtn: 'Manage Individual preferences',
                        // closeIconLabel: 'Reject all and close modal',
                        footer: `
                        <a href="/privacy-policy" target="_blank">Privacy Policy</a>
                    `,
                    },
                    preferencesModal: {
                        title: 'Manage cookie preferences',
                        acceptAllBtn: 'Accept all',
                        acceptNecessaryBtn: 'Reject all',
                        savePreferencesBtn: 'Accept current selection',
                        closeIconLabel: 'Close modal',
                        serviceCounterLabel: 'Service|Services',
                        sections: [{
                            title: 'Your Privacy Choices',
                            description: `In this panel you can express some preferences related to the processing of your personal information. You may review and change expressed choices at any time by resurfacing this panel via the provided link. To deny your consent to the specific processing activities described below, switch the toggles to off or use the “Reject all” button and confirm you want to save your choices.`,
                        },
                            {
                                title: 'Strictly Necessary',
                                description: 'These cookies are essential for the proper functioning of the website and cannot be disabled.',
                                //this field will generate a toggle linked to the 'necessary' category
                                linkedCategory: 'necessary'
                            },
                            {
                                title: 'Performance and Analytics',
                                description: 'These cookies collect information about how you use our website. All of the data is anonymized and cannot be used to identify you.',
                                linkedCategory: 'analytics',
                                // cookieTable: {
                                //     caption: 'Cookie table',
                                //     headers: {
                                //         name: 'Cookie',
                                //         domain: 'Domain',
                                //         desc: 'Description',
                                //         dur: 'Duration'
                                //     },
                                //     body: [{
                                //             name: '_ga',
                                //             domain: 'Google',
                                //             desc: 'Set by Google Analytics to recognize website users across multiple sessions.',
                                //         },
                                //         {
                                //             name: '_gid',
                                //             domain: 'Google',
                                //             desc: 'Description 2',
                                //         }
                                //     ]
                                // }
                            },
                            // {
                            //     title: 'Targeting and Advertising',
                            //     description: 'These cookies are used to make advertising messages more relevant to you and your interests. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and third party advertisers.',
                            //     linkedCategory: 'ads',
                            // },
                            // {
                            //     title: 'More information',
                            //     description: 'For any queries in relation to my policy on cookies and your choices, please <a href="#contact-page">contact us</a>'
                            // }
                        ]
                    }
                },

                hu: {
                    consentModal: {
                        title: 'Sütiket használunk!',
                        description: 'Üdvözlöm, ez a webhely alapvető sütiket használ a megfelelő működéséhez, és nyomkövető cookie-kat használ, hogy megértse, hogyan lép kapcsolatba vele. Ez utóbbit csak beleegyezés után állítják be.',
                        acceptAllBtn: 'Összes elfogadása',
                        acceptNecessaryBtn: 'Összes elutasítása',
                        showPreferencesBtn: 'Süti beállítások',
                        footer: `<a href="/privacy-policy" target="_blank">Privacy Policy</a>`,
                    },
                                        preferencesModal: {
                        title: 'Süti beállítások',
                        acceptAllBtn: 'Összes elfogadása',
                        acceptNecessaryBtn: 'Összes elutasítása',
                        savePreferencesBtn: 'Beállítások mentése',
                        closeIconLabel: 'Bezárás',
                        serviceCounterLabel: 'Service|Services',
                        sections: [{
                            title: 'Az Ön adatvédelmi választásai',
                        },
                            {
                                title: 'Szükséges',
                                description: 'Ezek a sütik elengedhetetlenek weboldal megfelelő működéséhez. Ezen sütik nélkül a weboldal nem működne megfelelően',
                                linkedCategory: 'necessary'
                            },
                            {
                                title: 'Teljesítmény és elemzés',
                                description: 'Ezek a sütik információkat gyűjtenek arról, hogy Ön hogyan használja a weboldalt, mely oldalakat látogatta meg, és mely linkekre kattintott. Az összes adat anonimizált, és nem használható fel az Ön azonosítására',
                                linkedCategory: 'analytics',

                            },
                            {
                                title: 'Targeting and Advertising',
                                description: 'These cookies are used to make advertising messages more relevant to you and your interests. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and third party advertisers.',
                                linkedCategory: 'ads',
                            },
                        ]
                    }
                }
            }
        }
    });
});

function initCookie(cc) {

    document.body.classList.add('cookie_theme');

    // cc.showSettings();

    // run plugin with your configuration
    cc.run({
        current_lang: 'en',
        autoclear_cookies: true,                   // default: false
        page_scripts: true,                        // default: false

        // mode: 'opt-out',                            // default: 'opt-in'; value: 'opt-in' or 'opt-out'
        // delay: 0,                               // default: 0
        auto_language: 'document',                    // default: null; could also be 'browser' or 'document'
        autorun: true,                              // default: true
        force_consent: false,                   // default: false
        // hide_from_bots: false,                  // default: false
        // remove_cookie_tables: false             // default: false
        cookie_name: 'cc_cookie',               // default: 'cc_cookie'
        // cookie_expiration: 182,                 // default: 182 (days)
        // cookie_necessary_only_expiration: 182   // default: disabled
        // cookie_domain: location.hostname,       // default: current domain
        cookie_path: '/',                       // default: root
        // cookie_same_site: 'Lax',                // default: 'Lax'
        // use_rfc_cookie: false,                  // default: false
        // revision: 0,                            // default: 0
        gui_options: {
            consent_modal: {
                layout: 'cloud',               // box/cloud/bar
                position: 'bottom center',     // bottom/middle/top + left/right/center
                transition: 'slide',           // zoom/slide
                swap_buttons: false            // enable to invert buttons
            }
        },
        languages: {
            'en': cookieLangEn,
            'hu': cookieLangHu
        },
        categories: {
            necessary: {
                enabled: true
            },
            analytics: {
                enabled: false
            }
        },
        onFirstAction: function(user_preferences, cookie){
            // callback triggered only once
        },

        onAccept: function (cookie) {
            // ...
        },

        onChange: function (cookie, changed_preferences) {
            // ...
        }
    });


}
function observeSettingModal() {
    let targetNode = $('#s-cnt');

    // Létrehozunk egy MutationObserver-t
    let observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.attributeName === 'aria-hidden') {
                let status = mutation.target.getAttribute('aria-hidden');
                if(status === 'false') {
                    $('#cookeSwitch').prop('checked',true);
                }else {
                    $('#cookeSwitch').prop('checked',false);
                }
            }
        });
    });

    // Beállítjuk az observer figyelendő tulajdonságait
    let config = { attributes: true, childList: false, characterData: false, subtree: false };

    // Regisztráljuk az observer-t
    observer.observe(targetNode[0], config);
}

let cookieLangEn = {
    consent_modal: {
        title: 'We use cookies!',
        description: 'Hi, this website uses essential cookies to ensure its proper operation and tracking cookies to understand how you interact with it. The latter will be set only after consent. <button type="button" data-cc="c-settings" class="cc-link">Let me choose</button>',
        primary_btn: {
            text: 'Accept all',
            role: 'accept_all'              // 'accept_selected' or 'accept_all'
        },
        secondary_btn: {
            text: 'Reject all',
            role: 'accept_necessary'        // 'settings' or 'accept_necessary'
        }
    },
    settings_modal: {
        title: 'Cookie settings',
        save_settings_btn: 'Save settings',
        accept_all_btn: 'Accept all',
        reject_all_btn: 'Reject all',
        close_btn_label: 'Close',
        cookie_table_headers: [
            {col1: 'Name'},
            {col2: 'Domain'},
            {col3: 'Expiration'},
            {col4: 'Description'}
        ],
        blocks: [
            {
                title: 'Your current state',
                // description: 'I use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want. For more details relative to cookies and other sensitive data, please read the full <a href="#" class="cc-link">privacy policy</a>.'
            }, {
                title: 'Necessary',
                description: 'These cookies are essential for the proper functioning of my website. Without these cookies, the website would not work properly',
                toggle: {
                    value: 'necessary',
                    enabled: true,
                    readonly: true          // cookie categories with readonly=true are all treated as "necessary cookies"
                }
            }, {
                title: 'Preferences',
                description: 'These cookies allow the website to remember the choices you have made in the past',
                toggle: {
                    value: 'analytics',     // your cookie category
                    enabled: false,
                    readonly: false
                },
                cookie_table: [             // list of all expected cookies
                    {
                        col1: '^_ga',       // match all cookies starting with "_ga"
                        col2: 'google.com',
                        col3: '2 years',
                        col4: 'description ...',
                        is_regex: true
                    },
                    {
                        col1: '_gid',
                        col2: 'google.com',
                        col3: '1 day',
                        col4: 'description ...',
                    }
                ]
            }, {
                title: 'Statics',
                description: 'These cookies collect information about how you use the website, which pages you visited and which links you clicked on. All of the data is anonymized and cannot be used to identify you',
                toggle: {
                    value: 'targeting',
                    enabled: false,
                    readonly: false
                }
            }, {
                title: 'Marketing',
                description: '',
                toggle: {
                    value: 'targeting',
                    enabled: false,
                    readonly: false
                }
            }
        ]
    }
};
let cookieLangHu = {
    consent_modal: {
        title: 'Sütiket használunk!',
        description: 'Üdvözlöm, ez a webhely alapvető sütiket használ a megfelelő működéséhez, és nyomkövető cookie-kat használ, hogy megértse, hogyan lép kapcsolatba vele. Ez utóbbit csak beleegyezés után állítják be. <button type="button" data-cc="c-settings" class="cc-link">Hadd válasszak</button>',
        primary_btn: {
            text: 'Összes elfogadása',
            role: 'accept_all'              // 'accept_selected' or 'accept_all'
        },
        secondary_btn: {
            text: 'Összes elutasítása',
            role: 'accept_necessary'        // 'settings' or 'accept_necessary'
        }
    },
    settings_modal: {
        title: 'Süti beállítások',
        save_settings_btn: 'Beállítások mentése',
        accept_all_btn: 'Összes elfogadása',
        reject_all_btn: 'Összes elutasítása',
        close_btn_label: 'Bezárás',
        cookie_table_headers: [
            {col1: 'Név'},
            {col2: 'Domain'},
            {col3: 'Lejárat'},
            {col4: 'Leírás'}
        ],
        blocks: [
            {
                title: 'A jelenlegi állapotod',
                // description: 'I use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want. For more details relative to cookies and other sensitive data, please read the full <a href="#" class="cc-link">privacy policy</a>.'
            }, {
                title: 'Szükséges',
                description: 'Ezek a sütik elengedhetetlenek weboldal megfelelő működéséhez. Ezen sütik nélkül a weboldal nem működne megfelelően',
                toggle: {
                    value: 'necessary',
                    enabled: true,
                    readonly: true          // cookie categories with readonly=true are all treated as "necessary cookies"
                }
            }, {
                title: 'Teljseítmény',
                description: 'Ezek a sütik lehetővé teszik a webhely számára, hogy emlékezzen a múltban hozott döntéseire',
                toggle: {
                    value: 'analytics',     // your cookie category
                    enabled: false,
                    readonly: false
                },
                cookie_table: [             // list of all expected cookies
                    {
                        col1: '^_ga',       // match all cookies starting with "_ga"
                        col2: 'google.com',
                        col3: '2 years',
                        col4: 'description ...',
                        is_regex: true
                    },
                    {
                        col1: '_gid',
                        col2: 'google.com',
                        col3: '1 day',
                        col4: 'description ...',
                    }
                ]
            }, {
                title: 'Statisztika',
                description: 'Ezek a sütik információkat gyűjtenek arról, hogy Ön hogyan használja a weboldalt, mely oldalakat látogatta meg, és mely linkekre kattintott. Az összes adat anonimizált, és nem használható fel az Ön azonosítására',
                toggle: {
                    value: 'targeting',
                    enabled: false,
                    readonly: false
                }
            }, {
                title: 'Marketing',
                description: '',
                toggle: {
                    value: 'targeting',
                    enabled: false,
                    readonly: false
                }
            }
        ]
    }
};
